<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'User Rewards' : 'Deleted User Rewards'"
              ></h3>
              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/user-rewards/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="3">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="user"
                    solo
                    rounded
                    v-model="filter.user_id"
                    :items="users"
                    item-text="name"
                    item-value="id"
                    clearable
                    @click:clear="(filter.user_id = null), (page = 1)"
                    label="User"
                    @input="getData"
                    prepend-inner-icon="mdi-account"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="reward"
                    solo
                    rounded
                    v-model="filter.reward_id"
                    :items="rewards"
                    item-text="title"
                    item-value="id"
                    clearable
                    @click:clear="(filter.reward_id = null), (page = 1)"
                    label="Reward"
                    @input="getData"
                    prepend-inner-icon="mdi-gift"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col sm="3">
                  <v-btn
                    rounded
                    color="success"
                    :loading="isExcelloading"
                    :disabled="isExcelloading"
                    @click="generateExcel"
                  >
                    <v-icon left>mdi-file-excel</v-icon>
                    Export
                  </v-btn>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="$vuetify.breakpoint.mobile ? '60vh' : '70vh'"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>&nbsp; Sr. No.</th>
                      <th class="text-left" style="min-width: none">User Name</th>
                      <th class="text-left" style="min-width: none">User Email</th>
                      <th class="text-left" style="min-width: none">Reward Type</th>
                      <th class="text-left" style="min-width: none">Reward Value</th>
                      <th class="text-left" style="min-width: none">Day Number</th>
                      <th class="text-left" style="min-width: none">Week</th>
                      <th class="text-left" style="min-width: none">Company</th>
                      <th class="text-left" style="min-width: none">Reward Image</th>
                      <th class="text-left" style="min-width: none">Assigned Date</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="userRewards.length != 0">
                    <tr
                      v-for="(userReward, i) in userRewards"
                      :key="`user_reward_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': userRewards.length - 1 == i,
                      }"
                    >
                      <td>&nbsp;{{ i + 1 }}</td>
                      <td>
                        {{ userReward.user ? userReward.user.name : "" }}
                      </td>
                      <td>
                        {{ userReward.user ? userReward.user.email : "" }}
                      </td>
                      <td>
                        {{ userReward.reward && userReward.reward.reward_type ? userReward.reward.reward_type.name : "" }}
                      </td>
                      <td>
                        {{ userReward.reward ? userReward.reward.reward_value : "" }}
                      </td>
                      <td>
                        {{ userReward.reward && userReward.reward.day_number ? userReward.reward.day_number.name : "" }}
                      </td>
                      <td>
                        {{ userReward.reward && userReward.reward.week ? userReward.reward.week.name : "" }}
                      </td>
                      <td>
                        {{ userReward.reward && userReward.reward.company ? userReward.reward.company.name : "" }}
                      </td>
                      <td>
                        <v-btn
                          v-if="userReward.reward && userReward.reward.reward_image"
                          icon
                          text
                          :href="`${mediaUrl}${userReward.reward.reward_image}`"
                          color="primary"
                          target="_blank"
                        >
                          <v-icon>mdi-file-image-outline</v-icon>
                        </v-btn>
                        <span v-else>No Image</span>
                      </td>
                      <td>
                        {{ formatDate(userReward.created_at) }}
                      </td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(userReward.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Remove this User Reward</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="info"
                                @click="viewDetails(userReward)"
                              >
                                <v-icon dark> mdi-eye </v-icon>
                              </v-btn>
                            </template>
                            <span>View Details</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="success"
                                @click="Restore_this(userReward.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this User Reward</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="11" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- User Reward Details Dialog -->
      <v-dialog v-model="detailsDialog" max-width="800">
        <v-card rounded="xxl">
          <v-card-title class="headline">
            <v-icon left color="primary">mdi-gift</v-icon>
            User Reward Details
            <v-spacer></v-spacer>
            <v-btn icon @click="detailsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text v-if="selectedUserReward">
            <v-container>
              <v-row>
                <v-col md="6">
                  <v-card outlined>
                    <v-card-subtitle>User Information</v-card-subtitle>
                    <v-card-text>
                      <p><strong>Name:</strong> {{ selectedUserReward.user ? selectedUserReward.user.name : 'N/A' }}</p>
                      <p><strong>Email:</strong> {{ selectedUserReward.user ? selectedUserReward.user.email : 'N/A' }}</p>
                      <p><strong>Phone:</strong> {{ selectedUserReward.user ? selectedUserReward.user.phone : 'N/A' }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col md="6">
                  <v-card outlined>
                    <v-card-subtitle>Reward Information</v-card-subtitle>
                    <v-card-text>
                      <p><strong>Reward Type:</strong> {{ selectedUserReward.reward && selectedUserReward.reward.reward_type ? selectedUserReward.reward.reward_type.name : 'N/A' }}</p>
                      <p><strong>Reward Value:</strong> {{ selectedUserReward.reward ? selectedUserReward.reward.reward_value : 'N/A' }}</p>
                      <p><strong>Day Number:</strong> {{ selectedUserReward.reward && selectedUserReward.reward.day_number ? selectedUserReward.reward.day_number.name : 'N/A' }}</p>
                      <p><strong>Week:</strong> {{ selectedUserReward.reward && selectedUserReward.reward.week ? selectedUserReward.reward.week.name : 'N/A' }}</p>
                      <p><strong>Company:</strong> {{ selectedUserReward.reward && selectedUserReward.reward.company ? selectedUserReward.reward.company.name : 'N/A' }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="selectedUserReward.reward && selectedUserReward.reward.reward_image">
                <v-col md="12">
                  <v-card outlined>
                    <v-card-subtitle>Reward Image</v-card-subtitle>
                    <v-card-text class="text-center">
                      <img 
                        :src="`${mediaUrl}${selectedUserReward.reward.reward_image}`" 
                        style="max-width: 100%; max-height: 300px;"
                        alt="Reward Image"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12">
                  <v-card outlined>
                    <v-card-subtitle>Assignment Details</v-card-subtitle>
                    <v-card-text>
                      <p><strong>Assigned Date:</strong> {{ formatDate(selectedUserReward.created_at) }}</p>
                      <p><strong>Last Updated:</strong> {{ formatDate(selectedUserReward.updated_at) }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Success Dialog Box -->
      <v-dialog v-model="is_deleted_user_reward" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Success!</h1>
                      <br />
                      <h3>User Reward removed successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_user_reward = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "UserRewardsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        user_id: null,
        reward_id: null,
      },
      userRewards: [],
      users: [],
      rewards: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        "User Name": "user_name",
        "User Email": "user_email", 
        "Reward Type": "reward_type_name",
        "Reward Value": "reward_value",
        "Day Number": "day_number_name",
        "Week": "week_name",
        "Company": "company_name",
        "Assigned Date": "created_at",
      },
      isLoading: false,
      isExcelloading: false,
      delete_user_reward: false,
      is_deleted_user_reward: false,
      detailsDialog: false,
      selectedUserReward: null,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getUsers();
    this.getRewards();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword;
      
      if (this.filter.user_id !== null) {
        query += "&user_id=" + this.filter.user_id;
      }
      if (this.filter.reward_id !== null) {
        query += "&reward_id=" + this.filter.reward_id;
      }

      await axios
        .get(`user_rewards?${query}`)
        .then((response) => {
          this.userRewards = response.data.data;
          console.log("userRewards", this.userRewards);

          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    async getUsers() {
      try {
        const response = await axios.get("/users");
        this.users = response.data.data;
      } catch (error) {
        console.log("Error loading users:", error);
      }
    },
    async getRewards() {
      try {
        const response = await axios.get("/rewards");
        this.rewards = response.data.data.map(reward => ({
          id: reward.id,
          title: `${reward.reward_type ? reward.reward_type.name : 'N/A'} - ${reward.reward_value} (${reward.company ? reward.company.name : 'N/A'})`
        }));
      } catch (error) {
        console.log("Error loading rewards:", error);
      }
    },
    //Generate Excel
    async generateExcel() {
      this.isExcelloading = true;
      let query = "search_keyword=" + this.filter.search_keyword;
      if (this.filter.user_id !== null) {
        query += "&user_id=" + this.filter.user_id;
      }
      if (this.filter.reward_id !== null) {
        query += "&reward_id=" + this.filter.reward_id;
      }
      
      let response = await axios.get(`user_reward_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
      this.isExcelloading = false;
    },
    async Delete_this(id) {
      this.delete_user_reward = true;
      await axios
        .post(`/user_rewards/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_user_reward = false;
          this.is_deleted_user_reward = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async Restore_this(id) {
      await axios
        .post(`/user_rewards/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    viewDetails(userReward) {
      this.selectedUserReward = userReward;
      this.detailsDialog = true;
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
  },
};
</script>